import Layout from "../components/Layout";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import {useSelector} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {ProgressSpinner} from "primereact/progressspinner";
import {Toast} from "primereact/toast";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";


const EmployeeMatrix = () => {
    const primeToast = useRef(null);
    const {user} = useSelector((state) => state["auth"]);
    const [employeeMatrix, setEmployeeMatrix] = useState({isLoading: false, data: []});
    const [employeeWiseMatrix, setEmployeeWiseMatrix] = useState({isLoading: false, data: []});
    const [saveEmpMatrix, setSaveEmpMatrix] = useState([]);
    const [employeeWiseMatrixID, setEmployeeWiseMatrixID] = useState(0);
    const [opinionList, setOpinionList] = useState([]);
    const [start] = useState(0);
    const [userMatrixCompleteCount, setUserMatrixCompleteCount] = useState([]);
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    useEffect(() => {
        initFilters();
        getEmployeeMatrix();
        getActiveOpinionList();
        getUserMatrixCompleteCount(user.registerID);
    }, [])

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = {...filters};
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const initFilters = () => {
        setFilters({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},            
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            }
        });
        setGlobalFilterValue('');
    }

    const clearFilter = () => {
        initFilters();
    }

    const getUserMatrixCompleteCount = (id) => {
        axios.get(BASE_URL + "/api/EmployeeMatrix/GetUserMatrixCompleteCount/" + id)
            .then(response => {
                setUserMatrixCompleteCount(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }

    const getActiveOpinionList = () => {
        axios.get(BASE_URL + "/api/matrixopinion/GetAllActiveOpinion")
            .then(response => {
                setOpinionList(response.data)
            })
            .catch(e => {
                console.log(e)
            })
    }

    const getEmployeeMatrix = () => {
        setEmployeeMatrix({isLoading: true, data: []})
        axios.post(BASE_URL + "/api/EmployeeMatrix/GetEmployeeList/" + user.registerID, {})
            .then(response => {
                setEmployeeMatrix({isLoading: false, data: response.data})
            })
            .catch(e => {
                setEmployeeMatrix({isLoading: false, data: []})
                console.log(e)
            })
    }

    const getEmployeeWiseMatrix = (empMatrixId) => {
        setEmployeeWiseMatrix({isLoading: true, data: []})
        axios.post(BASE_URL + "/api/EmployeeMatrix/GetEmployeeWiseMatrix/" + empMatrixId, {})
            .then(response => {
                setEmployeeWiseMatrix({isLoading: false, data: response.data})
            })
            .catch(e => {
                setEmployeeWiseMatrix({isLoading: false, data: []})
                console.log(e)
            })
    }

    const empCodeBody = emp => {
        //console.log(emp.totalSupervisorComplete)
        return <span className={employeeWiseMatrixID === emp.registerID ? "text-primary" : "text-success"}
                     style={{cursor: "pointer"}}
                     onClick={() => {
                         setSaveEmpMatrix([])
                         setEmployeeWiseMatrixID(emp.registerID)
                         getEmployeeWiseMatrix(emp.registerID)
                     }}>
            {emp.employeeName}
            {/* {emp.employeeName}/{emp.designation}/{emp.department} */}
        </span>
    }

    const header = (
        <div className="table-header">
            <div className="d-flex justify-content-between">
                <div className="p-2" style={{marginLeft: "10px"}}>
                    Completed <span className="d-inline p-2 bg-success text-white font-bold"> {userMatrixCompleteCount.length !== 0 ? userMatrixCompleteCount[0].totalMatrixSupervisedCompleted : ""}</span>
                    &nbsp;out
                    of <span className="d-inline p-2 bg-primary text-white">{userMatrixCompleteCount.length !== 0 ? userMatrixCompleteCount[0].totalMatrixSupervisedUser : ""}</span>
                </div>

            </div>
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilter}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange}
                               placeholder="Keyword Search"/>
                </span>
                </div>
            </div>
        </div>
    );
    const footer = `In total there are ${employeeMatrix.data ? employeeMatrix.data.length : 0} Employee Matrix.`;

    const Table = (
        <DataTable value={employeeMatrix.data} resizableColumns paginator rows={8} first={start}
        header={header}
        filters={filters}
        dataKey="registerID"
        filterDisplay="menu"
        globalFilterFields={['employeeCode','employeeName', 'department', 'designation','roleName']}
        paginatorTemplate="RowsPerPageDropdown PageLinks  ">
            <Column field="employeeWiseMatrixID" header="employeeWiseMatrix ID" hidden={true}/>

            <Column field="employeeCode" style={{width: "10px"}} header="" body={(emp) => (
                <span>{Number(emp.totalSupervisorComplete) > 0 ?
                    <i className="bi bi-check-circle-fill text-success"/> :
                    <i className="bi bi-check-circle text-black"/>}
                </span>
            )}/>

            <Column field='employeeCode' header="Employee Name"  body={empCodeBody}/>

            <Column field='department' header="Department"/>
            <Column field='designation' header="Designation"/>

            {/*<Column body={actionBodyTemplate} header="Action" exportable={false} style={{minWidth: '4rem'}}/>*/}
        </DataTable>
    )

    const onOpinionChange = e => {
        const copyMatrixList = [...saveEmpMatrix]
        console.log("copyMatrixList")
        const employeewisematrixid = e.currentTarget.getAttribute("data-employeewisematrixid")
        const employeewisematrixlibraryid = e.currentTarget.getAttribute("data-employeewisematrixlibraryid")
        const matrixlibraryid = e.currentTarget.getAttribute("data-matrixlibraryid")
        const registerid = e.currentTarget.getAttribute("data-registerid")
        const roleMatrixOpinionID = e.currentTarget.value
        //EmployeeWiseMatrixID,EmployeeWiseMatrixLibraryID,MatrixLibraryID,RoleMatrixOpinionID,RegisterID
        const index = copyMatrixList.findIndex(value => value.EmployeeWiseMatrixLibraryID === employeewisematrixlibraryid)
        const obj = {
            // EmployeeWiseMatrixID:employeewisematrixid,
            EmployeeWiseMatrixLibraryID: employeewisematrixlibraryid,
            MatrixLibraryID: matrixlibraryid,
            RoleMatrixOpinionID: roleMatrixOpinionID,
            RegisterID: registerid,
            QuarterID:user.quarterID,
            addedBy: user.registerID.toString(),
            WillValue: null
        }
        if (index === -1) {
            copyMatrixList.push(obj)
            setSaveEmpMatrix(copyMatrixList)

        } else {
            obj.WillValue = copyMatrixList[index].WillValue
            copyMatrixList.splice(index, 1)
            copyMatrixList.push(obj)
            setSaveEmpMatrix(copyMatrixList)
        }


    }

    const onWillChange = e =>{
        //console.log("dfdfdfd")
        const copySaveEmpMatrix = [...saveEmpMatrix]
        const employeewisematrixlibraryid = e.currentTarget.getAttribute("data-employeewisematrixlibraryid")
        const matrixlibraryid = e.currentTarget.getAttribute("data-matrixlibraryid")
        const registerid = e.currentTarget.getAttribute("data-registerid")
        const roleMatrixOpinionID = -2
        const index = copySaveEmpMatrix.findIndex(value => value.EmployeeWiseMatrixLibraryID === employeewisematrixlibraryid)
        if (index === -1){
            const obj = {
                EmployeeWiseMatrixLibraryID: employeewisematrixlibraryid,
                MatrixLibraryID: matrixlibraryid,
                RoleMatrixOpinionID: roleMatrixOpinionID,
                RegisterID: registerid,
                QuarterID:user.quarterID,
                addedBy: user.registerID.toString(),
                WillValue:e.currentTarget.value
            }
            copySaveEmpMatrix.push(obj)
        }else {
            copySaveEmpMatrix[index].WillValue = e.currentTarget.value
        }
        setSaveEmpMatrix(copySaveEmpMatrix)
        console.log(copySaveEmpMatrix);
    }

    const empWiseMatrixTable = (
        <>
            <table className="table">
                <thead className="table-light">
                <tr>
                    <th scope="col">Skill Title</th>
                    <th scope="col" className="text-center">Skill Rating</th>
                    <th scope="col" className="text-center">Will</th>
                </tr>
                </thead>
                <tbody>
                {employeeWiseMatrix.data.map(((value, index) => (<tr key={index}>
                    <td>{value.matrixTitle}</td>
                    <td><select className="form-select"
                                onChange={onOpinionChange}
                                data-employeewisematrixid={employeeWiseMatrixID}
                                data-employeewisematrixlibraryid={value.employeeWiseMatrixLibraryID}
                                data-matrixlibraryid={value.matrixLibraryID}
                                data-registerid={value.registerID}
                                defaultValue={value.roleMatrixOpinionID === null ? -1 : value.roleMatrixOpinionID}>
                        <option value={-1}>----select-----</option>
                        {opinionList.map((opinion, index) => (
                            <option key={index} value={opinion.roleMatrixOpinionID}>{opinion.title}</option>
                        ))}

                    </select></td>
                    <td>
                        <select className="form-select"
                                onChange={onWillChange}
                                data-employeewisematrixid={employeeWiseMatrixID}
                                data-employeewisematrixlibraryid={value.employeeWiseMatrixLibraryID}
                                data-matrixlibraryid={value.matrixLibraryID}
                                data-registerid={value.registerID}
                                defaultValue={value.willValue === null ? "Low" : value.willValue}>
                            <option value="Low">Low</option>
                            <option value="High">High</option>
                        </select>
                    </td>
                </tr>)))}


                </tbody>
            </table>
            {
                                user.isLocked === true ?(
                                    <h4 className="notUpdateComment" style={{fontSize:".8rem"}}>
                                    *** This Quarter Already Locked..!
                                  </h4>
                                ):
                                (
            <button
                disabled={saveEmpMatrix.length === 0}
                className="btn btn-primary" onClick={() => {
                    if (saveEmpMatrix.filter(item=>Number(item.RoleMatrixOpinionID) === -1).length > 0){
                        primeToast.current.show({
                            severity: 'error',
                            summary: 'error',
                            detail: 'Please select valid opinion',
                            life: 3000
                        });
                        return;
                    }
                if (saveEmpMatrix.length === employeeWiseMatrix.data.length) {
                    axios.post(BASE_URL + "/api/EmployeeMatrix/SaveEmployeeWiseMatrix", JSON.stringify(saveEmpMatrix))
                        .then(response => {
                            if (response.status === 200) {
                                getUserMatrixCompleteCount(user.registerID);
                                getEmployeeMatrix()
                                primeToast.current.show({
                                    severity: 'success',
                                    summary: 'success',
                                    detail: 'Matrix Save successfully',
                                    life: 3000
                                });
                            } else {
                                primeToast.current.show({
                                    severity: 'error',
                                    summary: 'error',
                                    detail: 'Unknown Error ',
                                    life: 3000
                                });
                            }
                        }).catch(e => {
                        console.log(e)
                        primeToast.current.show({
                            severity: 'error',
                            summary: 'error',
                            detail: 'Unknown Error ',
                            life: 3000
                        });
                    })
                } else {
                    const existList = employeeWiseMatrix.data.filter(item => item.roleMatrixOpinionID !== null)
                    if (existList.length > 0) {
                        axios.post(BASE_URL + "/api/EmployeeMatrix/SaveEmployeeWiseMatrix", JSON.stringify(saveEmpMatrix))
                            .then(response => {
                                if (response.status === 200) {
                                    getUserMatrixCompleteCount(user.registerID);
                                    primeToast.current.show({
                                        severity: 'success',
                                        summary: 'success',
                                        detail: 'Matrix Updated successfully',
                                        life: 3000
                                    });
                                } else {
                                    primeToast.current.show({
                                        severity: 'error',
                                        summary: 'error',
                                        detail: 'Unknown Error ',
                                        life: 3000
                                    });
                                }
                            }).catch(e => {
                            console.log(e)
                            primeToast.current.show({
                                severity: 'error',
                                summary: 'error',
                                detail: 'Unknown Error ',
                                life: 3000
                            });
                        })
                    } else {
                        primeToast.current.show({
                            severity: 'error',
                            summary: 'error',
                            detail: 'Please Complete All Matrix',
                            life: 3000
                        });
                    }

                }

            }}>Save Matrix</button>
            )}
        </>
    )

    return (
        <Layout>
            <Toast ref={primeToast}/>
            <div className="row">
            {/* <div className="d-flex justify-content-between">
                <div style={{marginLeft: "10px"}}>
                    Completed <span className="d-inline p-2 bg-success text-white font-bold"> {userMatrixCompleteCount.length !== 0 ? userMatrixCompleteCount[0].totalMatrixSupervisedCompleted : ""}</span>
                    &nbsp;out
                    of <span className="d-inline p-2 bg-primary text-white">{userMatrixCompleteCount.length !== 0 ? userMatrixCompleteCount[0].totalMatrixSupervisedUser : ""}</span>
                </div>

            </div> */}
                <div className="col-md-5">
                    {Table}
                </div>
                <div className="col-md-7">

                    {employeeWiseMatrix.isLoading ? <ProgressSpinner/> : ""}
                    {!employeeWiseMatrix.isLoading && employeeWiseMatrix.data.length !== 0 ? empWiseMatrixTable : ""}

                </div>

            </div>

        </Layout>
    )
}

export default EmployeeMatrix